import { render, staticRenderFns } from "./Contactform.vue?vue&type=template&id=2670334c&scoped=true&"
import script from "./Contactform.vue?vue&type=script&lang=js&"
export * from "./Contactform.vue?vue&type=script&lang=js&"
import style1 from "./Contactform.vue?vue&type=style&index=1&id=2670334c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670334c",
  null
  
)

export default component.exports